import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const SportCreator = () => {
  const { t } = useTranslation();
  
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('sport')}</Typography>
    </div>
  );
};

export default SportCreator;